import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';

import { alphaNumericRegex } from './regex';
import { HHInput } from './fields';
import { FORM_NAME } from '../forms/formConstant';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) => Yup.object().shape({
    linkedin: Yup.string().url(translate('form.error.string.url')),
    facebook: Yup.string()
      .matches(alphaNumericRegex, {
        excludeEmptyString: true,
        message: translate('form.error.regex.alphaNumeric')
      }),
    github: Yup.string(),
    twitter: Yup.string(),
    instagram: Yup.string(),
    behance: Yup.string(),
    dribbble: Yup.string(),
    youtube: Yup.string(),
    vimeo: Yup.string(),
    flickr: Yup.string(),
    pinterest: Yup.string()
  }),
  mapPropsToValues: (props) => (props.initialValues),
  handleSubmit: (values, { props }) => {
    props.handleSubmit(values);
  },
  displayName: FORM_NAME.EDIT_SOCIAL_FORM
});

const ProfileSocialMediaForm = ({ handleSubmit, isSubmitting, translate }) => (
  <Form onSubmit={handleSubmit} className='snsForm'>
    <Form.Field>
      <Field
        name='linkedin'
        component={HHInput}
        otherProps={{
          type: 'text',
          id: 'linkedin',
          className: 'sns-linkedin',
          icon: 'linkedin',
          iconPosition: 'left',
          placeholder: 'LinkedIn URL'
        }}
      />
    </Form.Field>

    <Form.Group widths='equal'>
      <Form.Field>
        <Field
          name='facebook'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'facebook',
            className: 'sns-facebook',
            icon: 'facebook',
            iconPosition: 'left',
            placeholder: 'Facebook ID'
          }}
        />
      </Form.Field>
      <Form.Field>
        <Field
          name='github'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'github',
            icon: 'github',
            iconPosition: 'left',
            placeholder: 'Github ID'
          }}
        />
      </Form.Field>
    </Form.Group>
    <Form.Group widths='equal'>
      <Form.Field>
        <Field
          name='twitter'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'twitter',
            icon: 'twitter',
            iconPosition: 'left',
            placeholder: 'Twitter ID'
          }}
        />
      </Form.Field>
      <Form.Field>
        <Field
          name='instagram'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'instagram',
            icon: 'instagram',
            iconPosition: 'left',
            placeholder: 'Instagram ID'
          }}
        />
      </Form.Field>
    </Form.Group>
    <Form.Group widths='equal'>
      <Form.Field>
        <Field
          name='behance'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'behance',
            icon: 'behance',
            iconPosition: 'left',
            placeholder: 'Behance ID'
          }}
        />
      </Form.Field>
      <Form.Field>
        <Field
          name='dribbble'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'dribbble',
            icon: 'dribble',
            iconPosition: 'left',
            placeholder: 'Dribbble ID'
          }}
        />
      </Form.Field>
    </Form.Group>
    <Form.Group widths='equal'>
      <Form.Field>
        <Field
          name='youtube'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'youtube',
            icon: 'youtube',
            iconPosition: 'left',
            placeholder: 'YouTube ID'
          }}
        />
      </Form.Field>
      <Form.Field>
        <Field
          name='vimeo'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'vimeo',
            icon: 'vimeo',
            iconPosition: 'left',
            placeholder: 'Vimeo ID'
          }}
        />
      </Form.Field>
    </Form.Group>
    <Form.Group widths='equal'>
      <Form.Field>
        <Field
          name='flickr'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'flickr',
            icon: 'flickr',
            iconPosition: 'left',
            placeholder: 'Flickr ID'
          }}
        />
      </Form.Field>
      <Form.Field>
        <Field
          name='pinterest'
          component={HHInput}
          otherProps={{
            type: 'text',
            id: 'pinterest',
            icon: 'pinterest',
            iconPosition: 'left',
            placeholder: 'Pinterest ID'
          }}
        />
      </Form.Field>
    </Form.Group>
    <div className='reactModal_footer'>
      <Button
        disabled={isSubmitting}
        loading={isSubmitting}
        primary
        content={translate('update')}
        size='large'
        type='submit'
        className='g-rounded'
      />
    </div>
  </Form>
);

export default compose(
  withLocalize,
  formikEnhancer
)(ProfileSocialMediaForm);



// WEBPACK FOOTER //
// ./src/components/forms/profileSocialMediaForm.js